export default "__VITE_ASSET__B9PC7kse__"